import { render, staticRenderFns } from "./add-desc.vue?vue&type=template&id=0e5993a4&scoped=true&"
import script from "./add-desc.vue?vue&type=script&lang=js&"
export * from "./add-desc.vue?vue&type=script&lang=js&"
import style0 from "./add-desc.vue?vue&type=style&index=0&id=0e5993a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5993a4",
  null
  
)

export default component.exports